// El front no lleva ninguna etiqueta ni color de estado fijos: todo viene del
// catálogo de la API (tabla estados_partido_visible). Estos helpers solo lo
// consultan.

export const indexarEstados = (estados) =>
  Object.fromEntries((estados ?? []).map((e) => [e.codigo, e]));

// Estilo en línea de la etiqueta de un estado. Si el código no está en el
// catálogo (p. ej. un estado nuevo aún sin sembrar), cae a un gris neutro y
// muestra el código tal cual, en vez de romper la tabla.
export const estiloEstado = (estado) => ({
  backgroundColor: estado?.color_fondo ?? '#F1F3F5',
  color: estado?.color_letra ?? '#495057',
  borderColor: estado?.color_borde ?? '#CED4DA',
});

export const etiquetaEstado = (indice, codigo) => indice[codigo]?.etiqueta ?? codigo;

// 'YYYY-MM-DD' -> 'DD/MM/YYYY'. Sin pasar por Date: evita que la zona horaria
// mueva el día.
export const formatearFecha = (iso) => {
  if (!iso) return '—';
  const [anio, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${anio}`;
};

// Un partido "ya jugado" es el que tiene resultado propuesto o confirmado:
// solo esos tienen fila plegable con las puntuaciones.
export const tieneResultado = (partido) =>
  partido.estado === 'PROPUESTO' || partido.estado === 'CONFIRMADO';

// Hoy en 'YYYY-MM-DD' (hora de Madrid, igual que RevisarAplazamiento).
export const hoyISO = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' });

// Al local le toca comunicar el resultado por WhatsApp: sigue sin puntuación
// propuesta (PENDIENTE/APLAZADO) y sin justificante en revisión.
export const tocaComunicar = (p) =>
  p.lado === 'LOCAL' && ['PENDIENTE', 'APLAZADO'].includes(p.estado) && p.justificante_estado !== 'PENDIENTE';

// El icono parpadea solo cuando ya urge: programado/adelantado con la fecha de
// juego ya llegada, o aplazado con plazo para jugar. Nunca en jornadas futuras
// sin aplazar/adelantar ni en W.O. (victoria por ausencia, penalización, anulado).
export const debeParpadear = (p, hoy) => {
  if (!tocaComunicar(p)) return false;
  if (/^(VICTORIA_|PENALIZACION|ANULADO)/.test(p.estado_codigo ?? '')) return false;
  if (p.estado === 'APLAZADO') return p.fecha_limite_jugar != null;
  const fechaJuego = p.fecha_jugado ?? p.fecha;
  return fechaJuego != null && fechaJuego <= hoy;
};

// Agrupa por modalidad conservando el orden de las modalidades en las que
// está inscrito el jugador (las que vienen en `inscripciones`); las tablas
// salen aunque aún no haya partidos. Dentro de cada una, por jornada.
export const agruparPorModalidad = (partidos, inscripciones) => {
  const grupos = new Map();
  (inscripciones ?? []).forEach((i) => {
    if (!grupos.has(i.modalidad_id)) grupos.set(i.modalidad_id, { modalidadId: i.modalidad_id, modalidad: i.modalidad, partidos: [] });
  });
  (partidos ?? []).forEach((p) => {
    if (!grupos.has(p.modalidad_id)) grupos.set(p.modalidad_id, { modalidadId: p.modalidad_id, modalidad: p.modalidad, partidos: [] });
    grupos.get(p.modalidad_id).partidos.push(p);
  });
  return [...grupos.values()]
    .sort((a, b) => a.modalidadId - b.modalidadId)
    .map((g) => ({ ...g, partidos: [...g.partidos].sort((a, b) => a.jornada - b.jornada) }));
};
